/**
 * 工具函数封装
 */
export function formateDate(date, rule) {
    let fmt = rule || 'yyyy-MM-dd hh:mm:ss'
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, date.getFullYear())
    }
    const o = {
        // 'y+': date.getFullYear(),
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    }
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            const val = o[k] + '';
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? val : ('00' + val).substr(val.length));
        }
    }
    return fmt;
}

//动态加载外部js
//@param RESOURCE_LIST 外部地址集合["address"]
export function loadVoLteResourceList(RESOURCE_LIST, success) {
    return new Promise(r => {
        RESOURCE_LIST.reduce((res, el) => res.then(() => loadScript(el)), Promise.resolve()).then(() => {
            r()
        }).catch((error) => {
            console.error('外呼VoLTE sdk 前置 js 资源加载失败:', error.name, error.message)
            return Promise.reject(error)
        })
    })
}

export function loadScript(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script')

        script.onload = () => resolve()

        script.onerror = () => reject(new Error(`Load script from ${url} failed`))

        script.src = url
        const head =
            document.head || document.getElementsByTagName('head')[0]
            ; (document.body || head).appendChild(script)
    })
}
// 字符串驼峰正则
export function transformStr3(str) {
    let re = /_(\w)/g
    return str.replace(re, ($0, $1) => {
        return $1.toUpperCase()
    })
}

export function toLine(name) {
    return name.replace(/([A-Z])/g, '-$1').toLowerCase()
}

export function formatToLine(value) {
    return value.replace(/([A-Z])/g, '_$1').toLowerCase()
}

// 表单行ID接口格式化
export function getformDetailitemsdata(data) {
    let typekey = 'val'
    if (!data.values) return ''
    return data.values.length > 0 ?
        data.compt === 'imagebox' ?
            data.values :
            data.values[0][typekey] : ''
}

let comptVal = ['editinput', 'edittextarea', 'autonumber', 'numberinput', 'dateinput', 'radiobutton', 'selectbox', 'richtext', 'areamultiselect', 'multipleselect', 'signature']
// 表单列表ID接口格式化 兼容数组
export function getformListItemsdatas(data) {
    // 若groupValues或 values有多个 则返回数组
    // 否则 先判断是compt返回结构是val 直接返回val数据 否则返回数组
    let formatItem = ''
    if (!data.groupValues) return ''
    if (data.groupValues.length > 1) {
        formatItem = data.groupValues.map(item => {
            return item.values[0][0]
        })
    } else {
        formatItem = data.groupValues[0].values ? data.groupValues[0].values.length > 1 ? data.groupValues[0].values : data.groupValues[0].values[0] : ''
    }
    if (formatItem !== undefined && formatItem.length && formatItem.length === 1) {
        let isVal = false
        let isHasVal = comptVal.filter(item => data.compt === item)
        if (isHasVal.length > 0) {
            isVal = true
            return formatItem[0].val !== '' ? formatItem[0].val : ''
        }
        if (!isVal) return formatItem
    } else {
        let isHasVal = comptVal.filter(item => data.compt === item)
        let result = formatItem
        if (isHasVal.length > 0) {
            result = formatItem.map(item => { return item.val })
        }
        return result
    }
}

// 表单列表ID接口格式化
export function getformListItemsdata(data) {
    let typekey = 'val'
    if (!data.groupValues) return ''
    if (!data.groupValues[0].values) return ''
    if (!data.groupValues[0].values[0].length === 0) return ''
    if (data.compt === 'imagebox') typekey = 'fileUrl'
    return data.groupValues[0].values[0].length && data.groupValues[0].values[0][0] ? data.groupValues[0].values[0][0][typekey] : ''
}


// 处理请求协议
export function handleHttp(val) {
    let currenthttp = location.protocol
    return val.indexOf(currenthttp) > -1 ? val : val.replace(val.match(/(\S*)\/\//i)[1], currenthttp)
}
export function getImg(el) {
    let id = el.objectId ? el.objectId : el.objectid
    return handleHttp(`${location.protocol}//museum.chaoxing.com/star3/origin/${id}.${el.suffix}`)
}

// formdata构造返回数据函数
export function getformdata(data, val) {
    if (!data.values) return ''
    if (!data.values[0]) return ''
    if (!data.values[0][0]) return ''
    if (val !== undefined) {
        return val === 'fileUrl' || 'playUrl' ? handleHttp(data.values[0][0][val]) : data.values[0][0][val]
    } else {
        return data.values[0][0].val !== '' ? data.values[0][0].val : ''
    }
}

// formdataList构造返回数据函数
export function getformdataList(data, val) {
    if (!data.values) return ''
    if (!data.values[0]) return ''
    if (data.compt == 'imagebox') return `https://museum.chaoxing.com/star3/origin/${data.values[0].objectId}.${data.values[0].suffix}`
    return data.values[0].val !== '' ? data.values[0].val : ''
}

// 字节转换
export function sizeFilter($bytesize) {
    let $i = 0
    // 当$bytesize 大于是1024字节时，开始循环，当循环到第4次时跳出；
    while (Math.abs($bytesize) >= 1024) {
        $bytesize = $bytesize / 1024
        $i++
        if ($i === 4) break
    }
    // 将Bytes,KB,MB,GB,TB定义成一维数组；
    const $units = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    const $newsize = Math.round($bytesize, 2)
    return $newsize + $units[$i]
}

// 处理表单文件字段添加/编辑数据格式 getImg(item)
export function formfileHandle(data, name, uid) {
    return data.map(item => {
        let newObj = {}
        if (name === 'imagebox' || name === 'videobox' || name === 'fileupload') {
            const objectId = item.objectid || item.objectId
            newObj = {
                name: item.name,
                objectId: objectId,
                byteSize: item.byteSize || item.size,
                size: item.byteSize ? item.size : sizeFilter(item.size),
                suffix: item.suffix ? item.suffix : item.http.split(objectId)[1],
                fileUrl: item.http || item.fileUrl,
                modifyDate: new Date().getTime(),
                resid: '',
                puid: uid
            }
            // handleHttp(item.http)
            if (name === 'videobox') {
                newObj.fileUrl = ''
                newObj.duration = ''
                newObj.videoHeight = 0
                newObj.videoWidth = 0
            }
            if (name === 'fileupload') newObj.fileUrl = ''
        }
        if (name && name === 'location') {
            newObj = {
                address: item.address,
                lng: item.lng,
                lat: item.lat,
                street: item.street,
                country: '',
                province: item.province,
                city: item.city,
                district: item.district,
                township: item.streetNumber || item.street_number,
            }
        }
        return newObj
    })
}

// 表单字段获取默认值 判断
export function getdefaultVal(item) {
    return item.compt === 'selectbox' || item.compt === 'radiobutton'
}

// 表单判断文件字段（图片/文件上传/视频）
export function getFileStatus(item) {
    return item.compt === 'imagebox' || item.compt === 'fileupload' || item.compt === 'videobox'
}

// 判断在微信的什么环境
export function isWx() {
    let ua = navigator.userAgent.toLowerCase()
    console.log(`ua`, ua)
    if (ua.indexOf('micromessenger') > -1) {
        return new Promise(resolve => {
            if (ua.indexOf('miniprogram') > -1) {
                resolve('mini-wx')
            } else {
                resolve('wx')
            }
        })
    } else {
        return new Promise(resolve => {
            resolve('no-wx')
        })
    }
}

// 插入字符
export function insertStr(str, index, insertStr) {
    return str.substring(0, index) + insertStr + str.substring(index)
}

// 处理颜色
export function colorConfig(data, name) {
    let tl = data
    tl = tl.replace(/\uff08/g, '(')
    tl = tl.replace(/\uff09/g, ')')
    tl = tl.includes('(') ? tl.split('(')[1].replace(')', '') : tl
    document.documentElement.style.setProperty(name, tl)
}

// 处理图片大小
export function setImgsize(data, width, height) {
    // console.log(data)
    if (!data) return
    // https://p.ananas.chaoxing.com/star3/780_636cQ100/3f19f362ba96097d25c7bb7a2b7f4d0c.jpg
    let fileUrl = `${location.protocol}//p.ananas.chaoxing.com/star3${width ? `/${width}_${height}cQ100` : '/origin'}/${data.objectId || data.objectid}.${data.suffix}`
    return fileUrl
}

// 处理导航
export function locationHandle(detail, url) {
    if (url !== undefined) {
        // 处理前期没有route字段
        let locationurl = ''
        let newLng = ''
        let newLat = ''
        if (url.location !== undefined) {
            locationurl = url.location.replace(/，/, ',')
            let splitlUlr = locationurl.split(',')
            newLng = Number(splitlUlr[0])
            newLat = Number(splitlUlr[1])
        } else {
            locationurl = url.route[0].lng + ',' + url.route[0].lat
            // console.log(url.route[0])
            newLng = Number(url.route[0].lng)
            newLat = Number(url.route[0].lat)
        }
        let newUrl = ''
        let clocation = JSON.parse(localStorage.getItem('bdlocation'))
        let bd_gd = bd_decrypt(newLng, newLat)
        // let bdUrl = handleHttp('https://api.map.baidu.com/direction?origin='+ clocation.lat + ',' +clocation.lng+ '&destination=' + newLat + ',' + newLng + '&mode=driving&region='+encodeURIComponent(clocation.address.city)+'&destination_region=&output=html&src=')
        let bdUrl = 'https://uri.amap.com/navigation?from=' + clocation.lng + ',' + clocation.lat + ',起点&to=' + bd_gd.lng + ',' + bd_gd.lat + ',终点&mode=car&policy=1&src=mypage&callnative=0'

        var ua = window.navigator.userAgent.toLowerCase();
        //先判断是否微信浏览器
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            //再判断一下是否在小程序里
            wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                    wx.miniProgram.redirectTo({
                        url: '/pages/position/index?lng=' + newLng + '&lat=' + newLat + '&name=' + detail.place_name + '&address=' + (url.route[0].address ? url.route[0].address : '')
                    })
                } else {
                    if (detail.open) {
                        window.open(bdUrl)
                    } else {
                        if (detail.linkTarget !== undefined && detail.linkTarget === '是') {
                            window.open(bdUrl)
                        } else {
                            if (!detail.open) {
                                this.linkcontainerflag = true
                                this.iframeurl = bdUrl
                            }
                        }
                    }
                }
            })
        } else {
            if (detail.open) {
                window.open(bdUrl)
            } else {
                if (detail.linkTarget !== undefined && detail.linkTarget === '是') {
                    window.open(bdUrl)
                } else {
                    if (!detail.open) {
                        this.linkcontainerflag = true
                        this.iframeurl = bdUrl
                    }
                }
            }
        }
    }
}

// 计算两个时间差 返回小时
export function hoursBetween(timestamp1, timestamp2) {
    const date1 = new Date(timestamp1)
    const date2 = new Date(timestamp2)
    const diff = Math.abs(date2 - date1) // 计算两个日期之间的差值（毫秒）
    return diff / (1000 * 60 * 60) // 转换为小时
}
/*
** 格式化数据
*/
export function getformitemsdata(data) {
    switch (data.compt) {
        case 'imagebox':
        case 'datetimerange':
        case 'checklist':
        case 'imagechecklist':
        case 'selectmultibox':
        case 'contact':
        case 'belonger':
        case 'department':
        case 'computeinput':
        case 'location':
        case 'livevideo':
        case 'fileupload':
        case 'videobox':
        case 'areacheckbox':
        case 'button':
            return data.values.length ? data.values : []
            break
        case 'detailcombox':
            return data.formDataList
            break
        default:
            return data.values.length && data.values[0] ? data.values[0].val : ''
            break
    }
}

//高德坐标转换百度坐标
export function gaoDeToBaidu(gd_lon, gd_lat) {
    let PI = 3.14159265358979324 * 3000.0 / 180.0;
    let x = gd_lon, y = gd_lat;
    let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * PI);
    let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * PI);
    let lng = z * Math.cos(theta) + 0.0065;//经度
    let lat = z * Math.sin(theta) + 0.006;//纬度
    return { lng, lat };
}

//百度坐标转换高德坐标
export function bd_decrypt(bd_lng, bd_lat) {
    var X_PI = Math.PI * 3000.0 / 180.0;
    var x = bd_lng - 0.0065;
    var y = bd_lat - 0.006;
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
    var gg_lng = z * Math.cos(theta);
    var gg_lat = z * Math.sin(theta);
    return { lng: gg_lng, lat: gg_lat }
}

export function formatRGBA(rgbaString) {
    // 移除字符串开头的空格
    rgbaString = rgbaString.trim()
    // 分割RGBA值
    let values = rgbaString.match(/^rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)$/)
    // 解析并返回RGBA对象
    return {
        r: parseInt(values[1], 10),
        g: parseInt(values[2], 10),
        b: parseInt(values[3], 10),
        a: parseFloat(values[4])
    }
}


// html转义字符 反转
export function unescapeHTML(str) {
    return str
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, "'")
        .replace(/&#x27;|&apos;/g, "'")
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
}

// html转义字符 
export function escapeHTML(str) {
    return str
        .replace(/"/g, "'")
}


/**
 * 处理表单结构方法
 */
export function getformatstruct(data, form, label, field, option) {
    return data.map(i => {
        form[i.alias] = ''
        // 表单字段名称
        label[i.alias] = i.label
        field[i.alias] = i.field
        // 表单字段默认值处理
        if (i.field && i.field.options) {
            i.field.options.forEach(item => {
                if (item.checked) form[i.alias] = item.title
            })
            option[i.alias] = i.field.options
        }
        let newItem = {
            alias: i.alias,
            compt: i.compt,
            values: i.values ? [] : [{ val: '' }]
        }
        // 提交数据时字段默认值
        if (i.values) {
            let defaultval = {}
            i.values.forEach(child => { defaultval[child] = '' })
            newItem.values = [defaultval]
        }
        return newItem
    })
}

// 处理导航
export function locationHandlev2(detail, url) {
    console.log(detail)
    console.log(url)
    if (url === undefined) return
    // 处理前期没有route字段
    let locationurl = ''
    let newLng = ''
    let newLat = ''
    locationurl = url.route[0].lng + ',' + url.route[0].lat
    newLng = Number(url.route[0].lng)
    newLat = Number(url.route[0].lat)
    let clocation = JSON.parse(localStorage.getItem('bdlocation'))
    let bd_gd = bd_decrypt(newLng, newLat)
    // let bdUrl = handleHttp('https://api.map.baidu.com/direction?origin='+ clocation.lat + ',' +clocation.lng+ '&destination=' + newLat + ',' + newLng + '&mode=driving&region='+encodeURIComponent(clocation.address.city)+'&destination_region=&output=html&src=')
    let bdUrl = 'https://uri.amap.com/navigation?from=' + clocation.lng + ',' + clocation.lat + ',起点&to=' + bd_gd.lng + ',' + bd_gd.lat + ',终点&mode=car&policy=1&src=mypage&callnative=0'

    var ua = window.navigator.userAgent.toLowerCase();
    //先判断是否微信浏览器
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //再判断一下是否在小程序里
        wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
                wx.miniProgram.navigateTo({
                    url: '/pages/position/index?lng=' + newLng + '&lat=' + newLat + '&name=' + detail.place_name + '&address=' + (url.route[0].address ? url.route[0].address : '')
                })
            } else {
                if (detail.open) {
                    window.open(bdUrl)
                } else {
                    if (detail.linkTarget !== undefined && detail.linkTarget === '是') {
                        window.open(bdUrl)
                    } else {
                        if (!detail.open) {
                            this.linkcontainerflag = true
                            this.iframeurl = bdUrl
                        }
                    }
                }
            }
        })
    } else {
        if (detail.open) {
            window.open(bdUrl)
        } else {
            if (detail.linkTarget !== undefined && detail.linkTarget === '是') {
                window.open(bdUrl)
            } else {
                if (!detail.open) {
                    this.linkcontainerflag = true
                    this.iframeurl = bdUrl
                }
            }
        }
    }

}

// 获取两点的 之间的经纬度
export function getPointsBetweenLatLong(lat1, lon1, lat2, lon2, numPoints) {
    const points = []
    const dLat = (lat2 - lat1) / numPoints
    const dLon = (lon2 - lon1) / numPoints
    for (let i = 0; i <= numPoints; i++) {
        const lat = lat1 + i * dLat
        const lon = lon1 + i * dLon
        points.push([lon, lat])
    }
    return points
}

//阶乘
export function factorial(num) {
    if (num <= 1) {
        return 1;
    } else {
        return num * factorial(num - 1);
    }
}

/*
 * 生成贝塞尔曲线插值点
 * @para n {number} 控制点数量
 * @para arrPoints {array} 控制点坐标集合
 */
export function createBezierCurvePoints(n, arrPoints) {
    var Ptx = 0;
    var Pty = 0;

    var arrbline = [];
    for (var t = 0; t < 1; t = t + 0.01) {
        Ptx = 0;
        Pty = 0;
        for (var i = 0; i <= n; i++) {
            Ptx += (factorial(n) / (factorial(i) * factorial(n - i))) * Math.pow((1 - t), n - i) * Math.pow(t, i) * arrPoints[i][0];
            Pty += (factorial(n) / (factorial(i) * factorial(n - i))) * Math.pow((1 - t), n - i) * Math.pow(t, i) * arrPoints[i][1];
        }

        arrbline.push([Ptx, Pty]);
    }
    return arrbline;
}


export function _isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag;
}


export function convertJsonToLinearGradient(gradientData) {
    let _stops = _.cloneDeep(gradientData._stops)
    let data = _stops.sort((a, b) => a[1] - b[1])
    let gradientStops = data.map(([color, position]) => {
        let positionPercent = `${(position * 100).toFixed(0)}%`
        return `${color} ${positionPercent}`
    })
    // 使用模板字符串拼接成 linear-gradient 的 CSS 值
    let cssLinearGradient = `linear-gradient(${gradientData._angle}deg, ${gradientStops.join(', ')})`
    console.log(`cssLinearGradient`, cssLinearGradient)
    return cssLinearGradient
}

export function convertLinearGradientToJson(cssGradient) {
    // 正则表达式用于匹配 linear-gradient 的各个部分
    const regex = /linear-gradient\s*\((\d+)deg,\s*(.*?)\)/;
    const match = cssGradient.match(regex);

    if (!match) {
        throw new Error('Invalid CSS linear-gradient value');
    }

    // 渐变方向（角度）
    const angle = parseInt(match[1], 10);

    // 颜色停止点字符串
    const stopString = match[2];

    // 进一步解析颜色停止点
    const stops = stopString.split(',').map(stop => {
        // 匹配颜色值和位置
        const stopRegex = /(#[0-9A-Fa-f]{6,8})\s*(\d*\.?\d*%)?/;
        const stopMatch = stop.trim().match(stopRegex);

        if (!stopMatch) {
            throw new Error('Invalid stop in CSS linear-gradient value');
        }

        const color = stopMatch[1];
        let position = stopMatch[2];

        // 将位置从百分比字符串转换为小数，如果位置不存在则默认为 null
        position = position ? parseFloat(position.replace('%', '')) / 100 : null;

        return [color, position];
    });

    // 构建 JSON 对象
    const gradientData = {
        _stops: stops,
        _limit: null, // 此字段在 CSS 中没有对应信息，可以省略或根据需求设置
        _type: 'linear', // 已知是线性渐变
        _angle: angle // 渐变方向的角度
    };

    return gradientData;
}

export function MD5(string) {
    function md5_RotateLeft(lValue, iShiftBits) {
        return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
    }
    function md5_AddUnsigned(lX, lY) {
        var lX4, lY4, lX8, lY8, lResult;
        lX8 = (lX & 0x80000000);//2147483648
        lY8 = (lY & 0x80000000);//2147483648
        lX4 = (lX & 0x40000000);//1073741824
        lY4 = (lY & 0x40000000);//1073741824
        lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
        if (lX4 & lY4) {
            return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
        }
        if (lX4 | lY4) {
            if (lResult & 0x40000000) {
                return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
            } else {
                return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
            }
        } else {
            return (lResult ^ lX8 ^ lY8);
        }
    }
    function md5_F(x, y, z) {
        return (x & y) | ((~x) & z);
    }
    function md5_G(x, y, z) {
        return (x & z) | (y & (~z));
    }
    function md5_H(x, y, z) {
        return (x ^ y ^ z);
    }
    function md5_I(x, y, z) {
        return (y ^ (x | (~z)));
    }
    function md5_FF(a, b, c, d, x, s, ac) {
        a = md5_AddUnsigned(a, md5_AddUnsigned(md5_AddUnsigned(md5_F(b, c, d), x), ac));
        return md5_AddUnsigned(md5_RotateLeft(a, s), b);
    };
    function md5_GG(a, b, c, d, x, s, ac) {
        a = md5_AddUnsigned(a, md5_AddUnsigned(md5_AddUnsigned(md5_G(b, c, d), x), ac));
        return md5_AddUnsigned(md5_RotateLeft(a, s), b);
    };
    function md5_HH(a, b, c, d, x, s, ac) {
        a = md5_AddUnsigned(a, md5_AddUnsigned(md5_AddUnsigned(md5_H(b, c, d), x), ac));
        return md5_AddUnsigned(md5_RotateLeft(a, s), b);
    };
    function md5_II(a, b, c, d, x, s, ac) {
        a = md5_AddUnsigned(a, md5_AddUnsigned(md5_AddUnsigned(md5_I(b, c, d), x), ac));
        return md5_AddUnsigned(md5_RotateLeft(a, s), b);
    };
    function md5_ConvertToWordArray(string) {
        var lWordCount;
        var lMessageLength = string.length;
        var lNumberOfWords_temp1 = lMessageLength + 8;
        var lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
        var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
        var lWordArray = Array(lNumberOfWords - 1);
        var lBytePosition = 0;
        var lByteCount = 0;
        while (lByteCount < lMessageLength) {
            lWordCount = (lByteCount - (lByteCount % 4)) / 4;
            lBytePosition = (lByteCount % 4) * 8;
            lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount) << lBytePosition));
            lByteCount++;
        }
        lWordCount = (lByteCount - (lByteCount % 4)) / 4;
        lBytePosition = (lByteCount % 4) * 8;
        lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
        lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
        lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
        return lWordArray;
    };
    function md5_WordToHex(lValue) {
        var WordToHexValue = "",
            WordToHexValue_temp = "",
            lByte, lCount;
        for (lCount = 0; lCount <= 3; lCount++) {
            lByte = (lValue >>> (lCount * 8)) & 255;
            WordToHexValue_temp = "0" + lByte.toString(16);
            WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length - 2, 2);
        }
        return WordToHexValue;
    };
    function md5_Utf8Encode(string) {
        string = string.replace(/\r\n/g, "\n");
        var utftext = "";
        for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n);
            if (c < 128) {
                utftext += String.fromCharCode(c);
            } else if ((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            } else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }
        }
        return utftext;
    };
    var x = Array();
    var k, AA, BB, CC, DD, a, b, c, d;
    var S11 = 7,
        S12 = 12,
        S13 = 17,
        S14 = 22;
    var S21 = 5,
        S22 = 9,
        S23 = 14,
        S24 = 20;
    var S31 = 4,
        S32 = 11,
        S33 = 16,
        S34 = 23;
    var S41 = 6,
        S42 = 10,
        S43 = 15,
        S44 = 21;
    string = md5_Utf8Encode(string);
    x = md5_ConvertToWordArray(string);
    a = 0x67452301;//1732584193
    b = 0xEFCDAB89;//4023233417
    c = 0x98BADCFE;//2562383102
    d = 0x10325476;//271733878
    for (k = 0; k < x.length; k += 16) {
        AA = a;
        BB = b;
        CC = c;
        DD = d;
        a = md5_FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
        d = md5_FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
        c = md5_FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
        b = md5_FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
        a = md5_FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
        d = md5_FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
        c = md5_FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
        b = md5_FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
        a = md5_FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
        d = md5_FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
        c = md5_FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
        b = md5_FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
        a = md5_FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
        d = md5_FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
        c = md5_FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
        b = md5_FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
        a = md5_GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
        d = md5_GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
        c = md5_GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
        b = md5_GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
        a = md5_GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
        d = md5_GG(d, a, b, c, x[k + 10], S22, 0x2441453);
        c = md5_GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
        b = md5_GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
        a = md5_GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
        d = md5_GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
        c = md5_GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
        b = md5_GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
        a = md5_GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
        d = md5_GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
        c = md5_GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
        b = md5_GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
        a = md5_HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
        d = md5_HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
        c = md5_HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
        b = md5_HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
        a = md5_HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
        d = md5_HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
        c = md5_HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
        b = md5_HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
        a = md5_HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
        d = md5_HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
        c = md5_HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
        b = md5_HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
        a = md5_HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
        d = md5_HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
        c = md5_HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
        b = md5_HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
        a = md5_II(a, b, c, d, x[k + 0], S41, 0xF4292244);
        d = md5_II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
        c = md5_II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
        b = md5_II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
        a = md5_II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
        d = md5_II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
        c = md5_II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
        b = md5_II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
        a = md5_II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
        d = md5_II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
        c = md5_II(c, d, a, b, x[k + 6], S43, 0xA3014314);
        b = md5_II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
        a = md5_II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
        d = md5_II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
        c = md5_II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
        b = md5_II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
        a = md5_AddUnsigned(a, AA);
        b = md5_AddUnsigned(b, BB);
        c = md5_AddUnsigned(c, CC);
        d = md5_AddUnsigned(d, DD);
    }
    return (md5_WordToHex(a) + md5_WordToHex(b) + md5_WordToHex(c) + md5_WordToHex(d)).toLowerCase();
}